import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'react-bootstrap-button-loader';
import { get, post, put } from '../../redux/modules/partners';
import FieldInput from '../../components/Field/Field';
import Image from '../../components/image/Image';
import * as Validations from '../../validations/validations';

const FORM_NAME = 'PartnerForm';

class PartnerForm extends PureComponent {

  handlerSubmit(values) {
    const { getAction, putAction, postAction, close } = this.props;
    const newData = { ...values };
    if (newData.id > 0) {
      return putAction(newData.id, newData)
        .then(() => {
          close();
          getAction();
        });
    }
    return postAction(newData).then(() => {
      close();
      getAction();
    });
  }

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <form
        className="planet-form planet-form__partner"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <div className="row">
          <div className="col-xs-6 col-sm-offset-3">
            <div className="row">
              <div className="col-xs-6 col-sm-offset-3">
                <Field
                  label="Name"
                  name="name"
                  validate={[Validations.required, Validations.minLength2]}
                  component={FieldInput}/>
                <Field
                  label="Url"
                  name="url"
                  validate={[Validations.required, Validations.minLength2]}
                  component={FieldInput}/>
              </div>
            </div>

            <div className="row">
              <div className="col-xs-6 col-sm-offset-3">
                <Field
                  validate={[Validations.required, Validations.minLength2]}
                  name="image"
                  component={Image}/>
              </div>
            </div>

          </div>
        </div>
        <div className="clearfix"></div>

        <div className="row">
          <div className="col-xs-6 col-sm-offset-3">
            <div className="row">
              <div className="col-xs-6 col-sm-offset-3">
                <Button disabled={pristine || submitting} loading={submitting} type="submit"
                        className="btn btn-xl">Save</Button>
                <Button disabled={pristine || submitting} loading={submitting} type="button" className="btn btn-xl"
                        onClick={reset}>Clear</Button>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      postAction: post,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/partner/index.js